const img = x => `memberships/${x}`

const memberships = [
  {
    id: "STAR-100",
    image: img("all"),
    name: "Star Membership Package",
    price: 218.97,
    description: "2 boxes of 15 sachets each",
  },
  {
    id: "SUP-100",
    image: img("all"),
    name: "Supreme Membership Package",
    price: 875.85,
    description: "8 boxes of 15 sachets each",
  },
  {
    id: "SPE-100",
    image: img("all"),
    name: "Super Membership Package",
    price: 1955.39,
    description: "20 boxes of 15 sachets each",
  },
]

exports.__esModule = true
exports.memberships = memberships
